import {Alert, Button, message, Modal, Tabs} from "antd";
import TabPane from "antd/es/tabs/TabPane";
import TextArea from "antd/es/input/TextArea";
import {useLayoutEffect, useState} from "react";

export const AutoCreate = () => {
    const [username, setUsername] = useState('Nguyễn Đình Tuấn');
    const [openModal, setOpenModal] = useState(false);
    
    const showModal = () => {
        setOpenModal(true);
    }
    const handleOk = () => {
        setOpenModal(false);
    }

    const tabItems = [
        {
            tab: "Thư mời phỏng vấn",
            key: 1,
        },
        {
            tab: "Thư mời nhận việc",
            key: 2,
        },
        {
            tab: "Thư từ chối",
            key: 3,
        },
    ]
    return (
        <div className="p-4">
            <Alert
                message="Thiết lập thư mời tự động"
                description={
                    <ul className="list-disc pl-5 text-sm text-gray-700">
                        <li>Yêu cầu viết tiếng Việt có dấu và đúng chính tả.</li>
                        <li>Nội dung thư mời tự động sẽ được sử dụng khi bạn liên hệ với ứng viên.</li>
                        <li>
                            Bạn có thể sử dụng dữ liệu tự động sau trong nội dung thư mời:
                            <br/>
                            - Tên ứng viên: <span className="text-red-500">[TEN_UNG_VIEN]</span>
                            <br/>
                            - Tên công ty: <span className="text-red-500">[TEN_CONG_TY]</span>
                        </li>
                    </ul>
                }
                type="info"
                showIcon
            />
            <div className="mt-4">
                <Tabs defaultActiveKey="1">
                    {
                        tabItems.map((item, index) => (
                            <TabPane tab={item.tab} key={item.key}>
                                <div className="space-y-2">
                                    <div className="flex flex-col gap-2 mb-2">
                                        <label className={"font-semibold text-md"}>
                                            Dữ liệu tự động
                                        </label>
                                        <div className={"flex gap-4"}>
                                            <Button className="bg-gray-200">Tên ứng viên</Button>
                                            <Button className="bg-gray-200">Tên công ty</Button>
                                        </div>
                                    </div>
                                    <label className={"font-semibold text-md"}>
                                        Nội dung <p className={"lowercase inline"}>{item.tab}</p>
                                    </label>
                                    <TextArea rows={6} placeholder="Nhập nội dung thư mời phỏng vấn..."/>
                                </div>
                            </TabPane>
                        ))
                    }
                </Tabs>
                <Modal
                    title="Xem trước"
                    visible={openModal}
                    onOk={handleOk}
                    onCancel={handleOk}
                    footer={[
                        <Button key="back" onClick={handleOk}>
                            Quay lại
                        </Button>,
                        <Button key="submit" type="primary" onClick={handleOk}>
                            Lưu
                        </Button>,
                    ]}
                >
                    <p>Thư mời phỏng vấn</p>
                    <p>Người nhận: {username}</p>
                    <p>Nội dung: </p>
                    <p>Chúc mừng bạn đã được chọn vào vị trí Frontend Developer tại công ty TNHH Tinviet Software. Chúng
                        tôi rất hân hạnh được làm việc cùng bạn.</p>
                </Modal>
                <div className="flex justify-end gap-4 mt-4">
                    <Button className="bg-yellow-500 text-white" onClick={showModal}>Xem trước</Button>
                    <Button type="primary">Sao lưu</Button>
                </div>
            </div>
        </div>
    )
}